<template>
  <div class="breadcrumbContainer">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item v-for="(item, index) in path" :key="index">
        <span class="mbx" @click="go(item.names)">{{ item.name }}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["path"],
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    go(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 767px) {
  .mbx {
    cursor: pointer;
  }
  .mbx:hover {
    color: red;
  }
}
@media (max-width: 767px) {
  .breadcrumbContainer {
    display: none;
  }
}
</style>
